import { useTranslation } from 'react-i18next'

import LangLink from './LangLink'
import LanguageSwitcher from './LanguageSwitcher'
import Section from './Section'

function Footer() {
  const { t } = useTranslation()
  const email = t('contact.details.emailValue')
  const phone = t('contact.details.phoneValue')

  return (
    <Section as="footer" background="dark" space="lg" className="site-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img
            src="/intraveo-logo-lockup-light.svg"
            alt={t('home.logoAlt')}
            className="footer-logo"
            width={83}
            height={52}
          />
          <p className="footer-tagline">{t('footer.tagline')}</p>
          <p className="footer-desc">{t('home.lead')}</p>
        </div>

        <nav className="footer-cols" aria-label={t('footer.navAria')}>
          <div className="footer-col">
            <p className="eyebrow">{t('footer.cols.navigation')}</p>
            <ul>
              <li>
                <LangLink to="/">{t('nav.home')}</LangLink>
              </li>
              <li>
                <LangLink to="/about">{t('nav.about')}</LangLink>
              </li>
              <li>
                <LangLink to="/partners">{t('nav.partners')}</LangLink>
              </li>
              <li>
                <LangLink to="/partners/china">{t('partnerChina.title')}</LangLink>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="eyebrow">{t('footer.cols.products')}</p>
            <ul>
              <li>
                <LangLink to="/products">{t('footer.links.pp')}</LangLink>
              </li>
              <li>
                <LangLink to="/products">{t('footer.links.pe')}</LangLink>
              </li>
              <li>
                <span className="footer-muted">{t('footer.links.more')}</span>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="eyebrow">{t('footer.cols.business')}</p>
            <ul>
              <li>
                <LangLink to="/how-to-order">{t('nav.howToOrder')}</LangLink>
              </li>
              <li>
                <LangLink to="/incoterms-logistics">{t('nav.incoterms')}</LangLink>
              </li>
              <li>
                <LangLink to="/how-to-order">{t('nav.requestQuote')}</LangLink>
              </li>
              <li>
                <LangLink to="/faq">{t('nav.faq')}</LangLink>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="eyebrow">{t('footer.cols.contact')}</p>
            <ul>
              <li>{t('contact.details.addressValue')}</li>
              <li>
                <a href={`mailto:${email}`}>{email}</a>
              </li>
              <li>
                <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
              </li>
              <li>
                <LangLink to="/contact">{t('nav.contact')}</LangLink>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="eyebrow">{t('footer.cols.legal')}</p>
            <ul>
              <li>
                <LangLink to="/privacy">{t('footer.links.privacy')}</LangLink>
              </li>
              <li>
                <LangLink to="/terms">{t('footer.links.terms')}</LangLink>
              </li>
              <li>
                <LangLink to="/cookies">{t('footer.links.cookies')}</LangLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <div className="footer-bottom">
        <span>{t('footer.address')}</span>
        <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
        <LanguageSwitcher variant="footer" />
      </div>
    </Section>
  )
}

export default Footer
